import { InfoCircleFill } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Space, Typography } from 'antd';

import Alert from '@/components/shared/Alert';
import { openInNewTab } from '@/helpers';
import { enStatus, ICourse } from '@/interfaces/course';
import { IResult } from '@/interfaces/query';
import { coursesApi } from '@/services/course';
import { StyledProp } from '@/styled';

const BlockedBySomenone = ({ className }: StyledProp) => {
  const { hash } = useParams<{ hash: string }>();
  const { data: course } = coursesApi.endpoints.getCourse.useQueryState<IResult<ICourse>>(hash);

  if (course?.blocked_by !== enStatus.BLOCKED) {
    return null;
  }

  return (
    <Alert
      className={className}
      icon={<InfoCircleFill size={20} />}
      type='error'
      message={
        <>
          Verifique se seus dados de pagamento precisam ser atualizados para continuar acessando esse curso,{' '}
          <Typography.Link
            style={{ fontSize: 24, textDecoration: 'underline' }}
            onClick={() =>
              openInNewTab(
                'https://ajuda.eduzz.com/hc/pt-br/articles/1260806909249-Como-alterar-a-forma-de-pagamento-de-uma-assinatura-'
              )
            }
          >
            clique aqui
          </Typography.Link>{' '}
          e siga as orientações.
        </>
      }
      description={
        <Space direction='vertical' size={4}>
          Se está tudo certo com os seus dados de pagamento, entre em contato com o seu Produtor para saber mais.
          <Typography.Text>
            <b>Produtor</b>: {course?.producer?.name}
          </Typography.Text>
          <Typography.Text>
            <b>E-mail</b>: {course?.producer?.email}
          </Typography.Text>
        </Space>
      }
    />
  );
};

export default BlockedBySomenone;
